import LinkifyIt from 'linkify-it';
import tlds from 'tlds';

const linkifyIt = new LinkifyIt();
linkifyIt.tlds(tlds).add('mailto:', null).add('ftp:', null);

// Shared placeholder for variable replacement
const PLACEHOLDER = 'placeholder';

const VARIABLE_PATTERN_SRC = '\\{\\{\\.[\\w_]+\\}\\}';
const URL_ENCODED_VARIABLE_PATTERN_SRC = '%7B%7B\\.[\\w_]+%7D%7D';
const ANY_VARIABLE_PATTERN_SRC = `(${VARIABLE_PATTERN_SRC}|${URL_ENCODED_VARIABLE_PATTERN_SRC})`;
const HAS_VARIABLES_REGEX = new RegExp(ANY_VARIABLE_PATTERN_SRC, 'i');

export function getNormalizedUrl(url) {
  if (!url) {
    return '';
  }

  // Only do placeholder replacement if URL contains variable placeholders
  // This allows normalization (e.g., adding http://) while preserving the variable structure
  if (HAS_VARIABLES_REGEX.test(url)) {
    // Collect variables in order and replace them with a placeholder
    const variableMatches = [];
    const anyVariablePattern = new RegExp(ANY_VARIABLE_PATTERN_SRC, 'g');
    const urlWithPlaceholder = url.replace(anyVariablePattern, match => {
      variableMatches.push(match);
      return PLACEHOLDER;
    });

    // Normalize protocol (avoid linkifyIt.match because it truncates with placeholders)
    const hasProtocol = /^(https?|ftp):\/\//i.test(urlWithPlaceholder) || /^mailto:/i.test(urlWithPlaceholder);

    const normalizedUrl = hasProtocol ? urlWithPlaceholder : `http://${urlWithPlaceholder}`;

    // Rebuild: split on placeholder and interleave variables back
    const parts = normalizedUrl.split(PLACEHOLDER);
    if (parts.length !== variableMatches.length + 1) {
      return url; // fallback if structure unexpected
    }

    let result = parts[0];
    for (let i = 0; i < variableMatches.length; i++) {
      result += variableMatches[i] + parts[i + 1];
    }

    return result;
  }

  const matches = linkifyIt.match(url);
  return (matches && matches[0].url) || url;
}

/**
 * Note: This can return false positives.
 */
export function isUrlValid(url) {
  if (!url) {
    return false;
  }

  // URLs with variable placeholders ({{.VARIABLE_TYPE}} or %7B%7B.VARIABLE%7D%7D)
  // should be validated by replacing them with a placeholder and checking if the resulting URL is valid
  if (HAS_VARIABLES_REGEX.test(url)) {
    // Replace variable placeholders with a placeholder value for validation
    const variablePattern = new RegExp(VARIABLE_PATTERN_SRC, 'g');
    const urlEncodedPattern = new RegExp(URL_ENCODED_VARIABLE_PATTERN_SRC, 'g');
    let urlWithPlaceholder = url.replace(variablePattern, PLACEHOLDER);
    urlWithPlaceholder = urlWithPlaceholder.replace(urlEncodedPattern, PLACEHOLDER);
    return linkifyIt.test(urlWithPlaceholder);
  }

  return linkifyIt.test(url);
}

export default linkifyIt;
